import type { Theme } from '@ms/yammer-web-core-ui/dist/util/theme/fluent9/';
import { create } from 'zustand';
export interface BrandThemes {
  readonly light: Theme;
  readonly dark: Theme;
}

export type TokensAndStylesType = BrandThemes | null;

export interface ActiveNetworkBranding {
  readonly id: string;
  readonly name: string;
  readonly colorScheme: string;
  readonly tokensAndStyles: TokensAndStylesType;
}

interface BrandThemeState {
  readonly brandTheme: ActiveNetworkBranding | null;
  readonly isLoading: boolean;
  readonly error: string | null;

  setBrandTheme(brandTheme: ActiveNetworkBranding | null): void;
  setLoading(loading: boolean): void;
  setError(error: string | null): void;
}

export const useBrandThemeStore = create<BrandThemeState>((set) => ({
  brandTheme: null,
  isLoading: false,
  error: null,

  setBrandTheme: (brandTheme) =>
    set({
      brandTheme,
      error: null,
    }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error, isLoading: false }),
}));

export const useBrandTheme = () => useBrandThemeStore((state) => state.brandTheme);
export const useIsBrandThemeLoading = () => useBrandThemeStore((state) => state.isLoading);
export const useBrandThemeError = () => useBrandThemeStore((state) => state.error);

export const useSetBrandTheme = () => useBrandThemeStore((state) => state.setBrandTheme);
export const useSetBrandThemeLoading = () => useBrandThemeStore((state) => state.setLoading);
export const useSetBrandThemeError = () => useBrandThemeStore((state) => state.setError);
